import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    title: true,
    shortDescription: true,
    operations: true,
    meter: true,
    date: true,
    background: true,
    level: true,
    ownMeter: true,
    city: true,
    mainGoal: false
}

const validatorSlice = createSlice({
    name: "validators",
    initialState,
    reducers: {
        resetValidators: ( state ) => {
            return initialState
        },
        changeTitleValidator: ( state, action ) => {
            state.title = action.payload
        },
        changeShortDescValidator: ( state, action ) => {
            state.shortDescription = action.payload
        },
        changeOperationsValidator: ( state, action ) => {
            state.operations = action.payload
        },
        changeMeterValidator: ( state, action ) => {
            state.meter = action.payload
        },
        changeDateValidator: ( state, action ) => {
            state.date = action.payload
        },
        changeBackgroundDescValidator: ( state, action ) => {
            state.background = action.payload
        },
        changeLevelValidator: ( state, action ) => {
            state.level = action.payload
        },
        changeOwnMeterValidator: ( state, action ) => {
            state.ownMeter = action.payload
        },
        changeCityValidator: ( state, action ) => {
            state.city = action.payload
        },
        changeMainGoalValidator: ( state, action ) => {
            state.mainGoal = action.payload
        }
    }
})

export const {
    changeTitleValidator,
    changeShortDescValidator,
    changeOperationsValidator,
    changeMeterValidator,
    changeDateValidator,
    changeBackgroundDescValidator,
    changeLevelValidator,
    changeOwnMeterValidator,
    changeCityValidator,
} = validatorSlice.actions

export default validatorSlice


// WEBPACK FOOTER //
// ./src/state/slices/validatorSlice.js